<template>
  <section
    class="SeasonPlayerScreenView"
    data-theme="light"
  >
    <PlayerList
      v-if="regularPlayers.length > 0"
      title="Regulars"
      data-testid="regularList"
      :players="regularPlayers"
      isActive
    />
    <div
      v-else
      class="SeasonPlayerScreenView__emptyState"
      role="status"
      data-testid="playerEmptyState"
    >
      <Icon
        class="SeasonPlayerScreenView__emptyStateIcon"
        name="personRunning"
      />
      No players yet
    </div>
  </section>
</template>

<script lang="ts" setup>
import Icon from "@/components/Icon.vue";
import PlayerList from "@/components/PlayerList.vue";
import isTruthy from "@/lib/utils/boolean/isTruthy";
import useSeasonStore from "@/stores/useSeasonStore";
import { computed } from "vue";

const {
  seasonId,
} = defineProps<{
  seasonId: string,
}>();

const {
  getSeason,
} = useSeasonStore();

const season = computed(() => {
  return getSeason(seasonId);
});

const regularPlayers = computed(() => {
  if (!season.value) return [];

  return season.value?.season_regulars
    .map((seasonRegular) => seasonRegular.player)
    .filter(isTruthy)
    .sort((a, b) => a.name.localeCompare(b.name));
});
</script>

<style lang="scss" scoped>
.SeasonPlayerScreenView {
  display: grid;
  gap: 16px;
  padding: 16px;

  border-top: solid 1px var(--themeColorNeutral100);
}

.SeasonPlayerScreenView__emptyState {
  display: grid;
  place-content: center;
  justify-items: center;
  padding-block: 16px;

  color: var(--themeColorNeutral600);

  font-stretch: var(--fontWidthExtended);
  line-height: 1.5;
}

.SeasonPlayerScreenView__emptyStateIcon {
  --iconSize: 48px;
  margin-bottom: 16px;
  color: var(--themeColorNeutral150);
}
</style>
